import React, { Component } from 'react'
import '../projects.sass'
import { Button, Card, Descriptions, Divider } from 'antd'
import moment from 'moment'
import { getConfigData } from '../../../Services/LocalStorageService'
import { DownloadOutlined } from '@ant-design/icons'

export default class PaymentHistoryCard extends Component {
	downloadPdf = () => {
		window.open(this.props.invoiceUrl.url, '_blank')
	}
	render() {
		const { data, profileType } = this.props
		return (
			<Card
				style={{ marginTop: '20px' }}
				type='inner'
				title='Payment History'
				extra={
					this.props.invoiceUrl?.url && (
						<Button target='_blank' onClick={this.downloadPdf} style={{ color: '#00b3ff', border: '1px solid #00b3ff' }}>
							<DownloadOutlined style={{ position: 'relative', bottom: '3px' }} /> Download invoice
						</Button>
					)
				}
			>
				{data.map((data, index) => (
					<React.Fragment key={index}>
						<Descriptions labelStyle={{ color: '#84818A' }} style={{ marginTop: '20px' }}>
							<Descriptions.Item label='Transaction Date'>
								{moment
									.utc(data.transactionDate)
									.local()
									.format('DD/MM/YYYY')}
							</Descriptions.Item>
							{profileType === 'CONSUMER' ? <Descriptions.Item label='Project Cost'>{getConfigData().currency + ' ' + data.projectCost}</Descriptions.Item> : null}
							<Descriptions.Item label='Amount Paid'>
								{getConfigData().currency} {profileType === 'PILOT' ? data.amount : data.amountPaid}
							</Descriptions.Item>
						</Descriptions>
						<Divider></Divider>
					</React.Fragment>
				))}
			</Card>
		)
	}
}
